// Web-only strings for remote support («Soporte remoto», shared/REMOTE-SUPPORT.md), keys `web.rs.`, BOTH
// languages. Imported by the web client (through ./web.ts) AND by the Windows supporthost bundle on its own
// (src/supporthost/, which ships without the big generated tables), so keep this file dependency-free.
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.rs.title': 'Soporte remoto',
    'web.rs.ring.title': 'Soporte remoto',
    'web.rs.ring.from': '%@ te pide soporte remoto',
    'web.rs.ring.hint': 'Verás su pantalla y, si te lo permite, podrás usar su mouse y teclado.',
    'web.rs.ring.accept': 'Aceptar',
    'web.rs.ring.decline': 'Rechazar',
    'web.rs.ring.taken': 'Otro de tus dispositivos ya aceptó la solicitud.',
    'web.rs.ring.failed': 'No se pudo aceptar: la solicitud ya no está activa.',
    'web.rs.viewer.title': 'Pantalla de %@',
    'web.rs.viewer.waiting': 'Esperando la pantalla de %@…',
    'web.rs.status.connecting': 'Conectando…',
    'web.rs.status.reconnecting': 'Reconectando…',
    'web.rs.status.viewOnly': 'Sólo ver',
    'web.rs.status.control': 'Control activo',
    'web.rs.askControl': 'Pedir control',
    'web.rs.asked': 'Control pedido…',
    'web.rs.fullscreen': 'Pantalla completa',
    'web.rs.exitFullscreen': 'Salir de pantalla completa',
    'web.rs.end': 'Terminar',
    'web.rs.releaseHint': 'Ctrl+Alt+Mayús+R deja de enviar teclas',
    'web.rs.keysPaused': 'Las teclas ya no se envían. Haz clic en la pantalla para volver a enviarlas.',
    'web.rs.elevated': 'La ventana activa requiere permisos de administrador',
    'web.rs.noPermission': 'Su Mac no ha dado permiso de control; sólo puedes ver',
    'web.rs.ended': 'La sesión de soporte remoto terminó.',
    'web.rs.ended.link': 'Se perdió la conexión con %@: la sesión terminó.',
    'web.rs.ended.byPeer': '%@ terminó la sesión de soporte remoto.',
    'web.rs.post.requested': '%@ solicitó soporte remoto.',
    'web.rs.post.live': 'Soporte remoto con %@ en curso',
    'web.rs.post.ended': 'Soporte remoto con %1$@ · %2$@',
    'web.rs.post.endedShort': 'Soporte remoto con %@',
    'web.rs.post.declined': 'Solicitud de soporte remoto rechazada',
    'web.rs.post.cancelled': 'Solicitud de soporte remoto cancelada',
    'web.rs.post.expired': 'Solicitud de soporte remoto sin respuesta',
    'web.rs.post.join': 'Unirse',
    'web.rs.duration.lessThanMinute': 'menos de 1 min',
    'web.rs.duration.minutes': '%d min',
    'web.rs.duration.hours': '%1$d h %2$d min',
    'web.rs.notification.body': '%@ te pide soporte remoto',
  },
  en: {
    'web.rs.title': 'Remote support',
    'web.rs.ring.title': 'Remote support',
    'web.rs.ring.from': '%@ is asking for remote support',
    'web.rs.ring.hint': "You'll see their screen and, if they allow it, use their mouse and keyboard.",
    'web.rs.ring.accept': 'Accept',
    'web.rs.ring.decline': 'Decline',
    'web.rs.ring.taken': 'Another of your devices already accepted the request.',
    'web.rs.ring.failed': "Couldn't accept: the request is no longer active.",
    'web.rs.viewer.title': "%@'s screen",
    'web.rs.viewer.waiting': "Waiting for %@'s screen…",
    'web.rs.status.connecting': 'Connecting…',
    'web.rs.status.reconnecting': 'Reconnecting…',
    'web.rs.status.viewOnly': 'View only',
    'web.rs.status.control': 'Control on',
    'web.rs.askControl': 'Ask for control',
    'web.rs.asked': 'Control requested…',
    'web.rs.fullscreen': 'Full screen',
    'web.rs.exitFullscreen': 'Exit full screen',
    'web.rs.end': 'End',
    'web.rs.releaseHint': 'Ctrl+Alt+Shift+R stops sending keys',
    'web.rs.keysPaused': 'Keys are no longer sent. Click the screen to send them again.',
    'web.rs.elevated': 'The active window requires administrator rights',
    'web.rs.noPermission': "Their Mac hasn't granted control permission; you can only watch",
    'web.rs.ended': 'The remote support session ended.',
    'web.rs.ended.link': 'The connection with %@ was lost: the session ended.',
    'web.rs.ended.byPeer': '%@ ended the remote support session.',
    'web.rs.post.requested': '%@ asked for remote support.',
    'web.rs.post.live': 'Remote support with %@ in progress',
    'web.rs.post.ended': 'Remote support with %1$@ · %2$@',
    'web.rs.post.endedShort': 'Remote support with %@',
    'web.rs.post.declined': 'Remote support request declined',
    'web.rs.post.cancelled': 'Remote support request cancelled',
    'web.rs.post.expired': 'Remote support request not answered',
    'web.rs.post.join': 'Join',
    'web.rs.duration.lessThanMinute': 'under 1 min',
    'web.rs.duration.minutes': '%d min',
    'web.rs.duration.hours': '%1$d h %2$d min',
    'web.rs.notification.body': '%@ is asking for remote support',
  },
};
